import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './componenets/dashboard/dashboard.component';
import { AboutComponent } from './componenets/about/about.component';
import { AdvertisersComponent } from './componenets/advertisers/advertisers.component';
import { PrivacyPolicyComponent } from './componenets/privacy-policy/privacy-policy.component';
import { CookiesPolicyComponent } from './componenets/cookies-policy/cookies-policy.component';
import { LegalNoticeComponent } from './componenets/legal-notice/legal-notice.component';
import { ContactComponent } from './componenets/contact-ngrx/contact/contact.component';
import { PublicHomeComponent } from './componenets/public-home/public-home.component';
import { ProductDetailsNgrxComponent } from './componenets/producs-ngrx/product-details-ngrx/product-details-ngrx.component';
import { GeneralPolicyComponent } from './componenets/general-policy/general-policy.component';
import { PromotionCodeComponent } from './componenets/dashboard/promotion-code/promotion-code.component';
import { ProductByAdvertiserComponent } from './componenets/producs-ngrx/product-by-advertiser/product-by-advertiser.component';
import { MenuMobileComponent } from './footer/menu-mobile/menu-mobile.component';
import { CameraCompratorComponent } from './componenets/comprator/products-comprator/camera/camera-comprator/camera-comprator.component';
import { VerifyEmailComponent } from './componenets/verify-email/verify-email.component';
import { NewsletterConfirmComponent } from './componenets/newsletter-pages/newsletter-confirm.component';
import { NewsletterUnsubscribeComponent } from './componenets/newsletter-pages/newsletter-unsubscribe.component';
import { ResetPasswordComponent } from './componenets/reset-password/reset-password.component';
import { SettingsComponent } from './componenets/settings/settings.component';
import { MessagesComponent } from './componenets/messages/messages.component';
import { MyAccountComponent } from './componenets/my-account/my-account.component';
import { PostDealComponent } from './componenets/post-deal/post-deal.component';


const routes: Routes = [
  {
    path: '',
    component: PublicHomeComponent,
    children: [
      { path: '', component: DashboardComponent ,  pathMatch: 'full' },
      { path: 'promotion', component: DashboardComponent },
      { path: 'category/:category', component: DashboardComponent },
      { path: 'advertiser/:advertiserName', component: ProductByAdvertiserComponent },
      // anciennes URLs (avant le renommage Source -> Advertiser), gardées pour le référencement
      { path: 'source/:advertiserName', redirectTo: 'advertiser/:advertiserName' },
      { path: 'promotionCode', component: PromotionCodeComponent },
      // « Offres près de moi » : offres en magasin autour de la position du visiteur (mode du dashboard)
      { path: 'pres-de-moi', component: DashboardComponent },
      { path: 'about', component: AboutComponent },
      { path: 'advertisers', component: AdvertisersComponent },
      { path: 'partner', redirectTo: 'advertisers', pathMatch: 'full' },
      { path: 'privacyPolicy', component: PrivacyPolicyComponent },
      { path: 'generalPolicy', component: GeneralPolicyComponent },
      { path: 'cookies', component: CookiesPolicyComponent },
      { path: 'legalNotice', component: LegalNoticeComponent },
      { path: 'product/:id', component: ProductDetailsNgrxComponent, /* resolve: ProductDetailResolver*/ },
      { path: 'contact', component: ContactComponent },
      { path: 'menuMobile', component: MenuMobileComponent },
      { path: 'verify-email/:token', component: VerifyEmailComponent },
      // Liens des e-mails de la newsletter (confirmation double opt-in, désinscription)
      { path: 'newsletter/confirm/:token', component: NewsletterConfirmComponent },
      { path: 'newsletter/unsubscribe/:token', component: NewsletterUnsubscribeComponent },
      { path: 'reset-password/:token', component: ResetPasswordComponent },
      { path: 'cameraComprator', component: CameraCompratorComponent },
      { path: 'settings', redirectTo: 'settings/profil', pathMatch: 'full' },
      { path: 'settings/:section', component: SettingsComponent },
      { path: 'messages', component: MessagesComponent },
      { path: 'messages/:userId', component: MessagesComponent },
      { path: 'compte', redirectTo: 'compte/saved', pathMatch: 'full' },
      { path: 'compte/:section', component: MyAccountComponent },
      { path: 'poster', component: PostDealComponent },
      { path: '404', component: DashboardComponent },
      { path: '**', component: DashboardComponent },
      { path: '*', component: DashboardComponent }
    ]
  },
  //redirect if not found url - example: localhost/anything
  { path: '**', redirectTo: '', pathMatch:'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
})],
exports: [RouterModule]
})
export class AppRoutingModule { }
